<div id="calender">
    <div id="showcase">
        <img src="/assets/img//showcase/11.jpeg" alt="banner" class="img-fluid w-100">
    </div>
    <div id="heading">
        <h1>Academic Calender</h1>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
              <li class="breadcrumb-item"><a href="#">Academic Calender</a></li>
              <li class="breadcrumb-item active" style="text-transform: capitalize;" aria-current="page">{{routeName}}</li>
            </ol>
          </nav>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-3">
                <nav id="secondary-navigation">
                    <!-- Header -->
                    <header class="header">
                        <h5>Academic Calender</h5>
                    </header>
                    <!-- /Header -->
                    <ul>
                        <li routerLinkActive="active">
                            <a routerLink="/calender/2026-27" (click)="changeRoute('2026-27')">2026-27</a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/calender/2025-26" (click)="changeRoute('2025-26')">2025-26</a>
                        </li>
                        <!-- <li routerLinkActive="active">
                            <a routerLink="/calender/2022-23" (click)="changeRoute('2022-23')">2022-23</a>
                        </li> -->
                    </ul>
                </nav>
            </div>
            <div class="col-md-9">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>